import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { getDataRequest } from "../../api/serviceMethods";
import { PAYMENT_URL } from "../../api/URLs";
import TablePaymentOrdinary from "./TablePaymentOrdinary";
import TablePaymentSuper from "./TablePaymentSuper";

const TablePaymentPage = ({ setLoading, messageModalRef }) => {
    const { t } = useTranslation();
    const [dates, setDates] = useState([null, null]);
    const [paymentData, setPaymentData] = useState([])
    const [memberType, setMemberType] = useState('pro');
    const [keyword, setKeyword] = useState('');
    const [dataObject, setDataObject] = useState({
        type: "",
        method: ""
    })
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    });

    const handleTabChange = (activeKey) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pagination: {
                ...prevParams.pagination,
                current: 1,
            },
        }));
        if (activeKey === 'ordinaryList') {
            setMemberType('pro');
            setKeyword("")
        }
        else if (activeKey === 'superList') {
            setMemberType('VIP');
            setKeyword("")
        }
    };

    const initLoadPayment = async () => {
        setLoading(true);
        await getDataRequest(`${PAYMENT_URL}`, {
            keyword: keyword.trim(),
            startDate: dates[0] || "",
            endDate: dates[1] || "",
            paymentType: dataObject.type,
            paymentMethod: dataObject.method,
            orderType: memberType,
            pageNo: tableParams.pagination.current,
            sortKeys: { [tableParams.sortField ? tableParams.sortField : "time"]: tableParams.sortOrder === "ascend" ? "asc" : "desc" },//descend
            pageSize: tableParams.pagination.pageSize,
        }).then(res => {
            setLoading(false);
            if (res.status === 200) {
                setPaymentData(res?.data);
                setTableParams(prevParams => ({
                    ...prevParams,
                    pagination: {
                        ...prevParams.pagination,
                        total: res.total,
                    },
                }));
            }
        }).catch((err) => {
            setLoading(false);
            console.log("Error", err);
        });
    };
    const [isSearch, setIsSearch] = useState(true)
    useEffect(() => {
        isSearch && initLoadPayment();
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sortOrder,
        tableParams?.sortField,
        JSON.stringify(tableParams.filters), isSearch, memberType
    ]);

    return (
        <Tabs
            defaultActiveKey="ordinaryList"
            className="cusStyle"
            onChange={handleTabChange}
        >
            <Tabs.TabPane tab={t("Ordinary member collection")} key="ordinaryList">
                <TablePaymentOrdinary
                    messageModalRef={messageModalRef}
                    paymentData={paymentData}
                    keyword={keyword}
                    setKeyword={setKeyword}
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    dates={dates}
                    setDates={setDates}
                    initLoadPayment={() => {
                        setIsSearch(false)
                        setTimeout(() => {
                            setIsSearch(true)
                        }, 100);
                    }}
                    memberType={memberType}
                    dataObject={dataObject} 
                    setDataObject={setDataObject}
                    isSearch={isSearch} setIsSearch={setIsSearch}
                />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t("Super member collection")} key="superList">
                <TablePaymentSuper
                    messageModalRef={messageModalRef}
                    paymentData={paymentData}
                    keyword={keyword}
                    setKeyword={setKeyword}
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    dates={dates}
                    setDates={setDates}
                    initLoadPayment={() => {
                        setIsSearch(false)
                        setTimeout(() => {
                            setIsSearch(true)
                        }, 100);
                    }}
                    memberType={memberType}
                    dataObject={dataObject} 
                    setDataObject={setDataObject}
                />
            </Tabs.TabPane>
        </Tabs>
    );
};

export default TablePaymentPage;
